import { EventSchema, userEvent, EventSource } from '../interfaces/EventInterfaces';
import analyticsProviderFactory from './AnalyticsProviderFactory';

const defaultProviderName = 'segment';


export class AnalyticsEvent {
  private readonly schema: EventSchema;
  private readonly sources: EventSource[];
  private eventSourceParams: { [source: string]: userEvent } = {};

  constructor(schema: EventSchema, sources: EventSource[]) {
    this.schema = schema;
    this.sources = sources.length === 0 ? [defaultProviderName] : sources;
  }

  createEventObject(params: { [key: string]: any }): void {
    this.sources.forEach(source => {
      const eventName = typeof this.schema.eventName === 'string' ? this.schema.eventName : this.schema.eventName[source];
      if (eventName) {
        this.eventSourceParams[source] = {
          eventName: eventName,
          params: {}
        };

        Object.entries(this.schema.params).forEach(([key, paramSchema]) => {
          if (typeof paramSchema === 'object' && paramSchema !== null && !Array.isArray(paramSchema)) {
            const paramName = paramSchema[source];
            if (paramName && params[key] !== undefined) {
              this.eventSourceParams[source].params[paramName] = params[key];
            }
          } else {
            const paramName = paramSchema;
            if (paramName && params[key] !== undefined) {
              this.eventSourceParams[source].params[paramName] = params[key];
            }
          }
        });
      }
    });
  }

  track(): void {
    this.sources.forEach(source => {
      const provider = analyticsProviderFactory.getProvider(source);
      const event = this.eventSourceParams[source];
      if (event) {
        provider.trackEvent(event);
      }
    });

  }
}